import { NotificationManager as NotificationManagerRN } from 'react-notifications';

const defaultTimeout = 500000;

export default class NotificationManager {
  static push(type, message, timeout) {
    const timeoutUsed = typeof timeout === 'number' ? timeout : defaultTimeout;
    switch (type) {
      case 'success':
        NotificationManagerRN.success(message, '', timeoutUsed);
        break;
      case 'error':
        NotificationManagerRN.error(message, '', timeoutUsed);
        break;
      case 'warning':
        NotificationManagerRN.warning(message, '', timeoutUsed);
        break;
      case 'info':
        NotificationManagerRN.info(message, '', timeoutUsed);
        break;
      default:
        NotificationManagerRN.success(message, '', timeoutUsed);
        break;
    }
  }
}
